import React from 'react';
import { mergeStyleSets } from '@fluentui/react';
import ItemDocumento from '../../models/ItemDocumento';

const docClasses = mergeStyleSets({
    container: {
        borderRadius: 8,
        overflow: 'hidden',
        border: '1px solid #f0f0f0',
        marginTop: 4,
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 12px',
        borderBottom: '1px solid #f0f0f0',
        selectors: {
            ':last-child': { borderBottom: 'none' },
            ':nth-child(even)': { backgroundColor: '#fafafa' },
        },
    },
    badge: {
        width: 38,
        height: 38,
        borderRadius: '50%',
        backgroundColor: 'var(--color-primario)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        color: 'white',
        fontSize: 10,
        fontWeight: 700,
        textTransform: 'uppercase',
    },
    content: {
        flex: 1,
        minWidth: 0,
    },
    fileName: {
        fontSize: 12,
        fontWeight: 600,
        color: '#333',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    meta: {
        fontSize: 11,
        color: '#888',
        marginTop: 2,
    },
    tag: {
        display: 'inline-block',
        backgroundColor: 'var(--color-primario)',
        color: 'white',
        borderRadius: 4,
        padding: '1px 6px',
        fontSize: 10,
        fontWeight: 600,
        marginLeft: 6,
    },
    preview: {
        width: 38,
        height: 38,
        objectFit: 'cover',
        borderRadius: 4,
        flexShrink: 0,
        border: '1px solid #eee',
    },
    emptyMsg: {
        padding: 16,
        color: '#aaa',
        fontSize: 13,
        textAlign: 'center',
    },
});

interface IWorkOrderDocumentsComponentProps {
    documents: ItemDocumento[];
};

const WorkOrderDocumentsComponent = (props: IWorkOrderDocumentsComponentProps) => {
    if (!props.documents || props.documents.length === 0) {
        return (
            <div className={docClasses.emptyMsg}>
                No hemos encontrado ningún documento en esta orden.
            </div>
        );
    }

    return (
        <div className={docClasses.container}>
            {props.documents.map((doc: ItemDocumento, index: number) => (
                <div key={doc.IdAuto || index} className={docClasses.row}>
                    {doc.EsFirma && doc.imgBase64 ? (
                        <img
                            src={doc.imgBase64}
                            alt="Firma"
                            className={docClasses.preview} />
                    ) : (
                        <div className={docClasses.badge}>
                            {doc.Extension ? doc.Extension.replace('.', '').substring(0, 4) : (doc.EsFirma ? 'FIR' : 'DOC')}
                        </div>
                    )}
                    <div className={docClasses.content}>
                        <div className={docClasses.fileName}>
                            {doc.NombreArchivo || doc.Descripcion || `Archivo ${index + 1}`}
                            {doc.EsFirma && <span className={docClasses.tag}>Firma</span>}
                        </div>
                        <div className={docClasses.meta}>
                            {[doc.Size, doc.fecDoc].filter(Boolean).join(' · ')}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default WorkOrderDocumentsComponent;

